import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SearchStoreService } from '@ecs-services/search/search-store.service';
import { isSparePartsDataResultOrIsFreeTextDataResult } from '@ecs-services/search/search.helper';
import { SearchError } from '@ecs-services/search/search.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { NgUseDirective, OnDestroyBase } from '@os-components';
import {
    SewNotification,
    SewNotificationStack,
    SewTabBar,
    SewTabBarItem,
} from '@sew/ui-components-angular/standalone';
import { Observable } from 'rxjs';
import { map, shareReplay, takeUntil } from 'rxjs/operators';
import { PartTableComponent } from '../../../components/part-table/part-table.component';
import { LoggedInDirective } from './../../../../../../lib-os-components/src/lib/directives/logged-in/logged-in.directive';
import { OrderNumberTableComponent } from './components/order-number-table/order-number-table.component';
import { OrderNumberItem } from './components/order-number-table/order-number-table.interface';
import { SparePartsCollection } from './spare-parts.interface';

@Component({
    selector: 'ecs-spare-parts-result',
    templateUrl: './spare-parts-result.component.html',
    styleUrls: ['./spare-parts-result.component.scss'],
    imports: [
        SewNotificationStack,
        SewNotification,
        SewTabBar,
        SewTabBarItem,
        NgUseDirective,
        NgTemplateOutlet,
        LoggedInDirective,
        PartTableComponent,
        OrderNumberTableComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class SparePartsResultComponent extends OnDestroyBase implements OnInit, OnDestroy {
    @Input() public searchResult?: Observable<SparePartsCollection | undefined>;
    public searchError?: Observable<SearchError | null | undefined>;
    public searchterm?: Observable<string[]>;

    public orderItems?: Observable<OrderNumberItem[] | null | undefined>;

    public constructor(private searchStore: SearchStoreService) {
        super();
    }

    public ngOnInit(): void {
        if (!this.searchResult) {
            this.searchResult = this.searchStore
                .getSearchResult(isSparePartsDataResultOrIsFreeTextDataResult, true)
                .pipe(
                    takeUntil(this.destroySubject),
                    map((sparePartsData) => sparePartsData ?? undefined)
                );
        }
        this.orderItems = this.searchStore.getOrderNumberSearchResult().pipe(
            takeUntil(this.destroySubject),
            map((orderNumberSearchResult) => orderNumberSearchResult?.orderItems)
        );

        this.searchError = this.searchStore.getSearchError().pipe(shareReplay());
        this.searchterm = this.searchStore.getSearchTerm();
    }
}
